import React from "react";
import {Link} from "react-router-dom";

const Service = ({data}) => {
    return (
        <>
            {data.length > 0 ?
                data.map((object) => (
                    <div
                        className="col-xl-4 col-lg-4 wow  fadeInUp animated"
                        data-wow-delay="0.1s"
                        style={{
                            visibility: "visible",
                            animationDelay: "0.1s",
                            animationName: "fadeInUp",

                        }}
                    >
                        <div className="services-one__single" style={{height:"400px"}}>
                            <div className="services-one__single-title" >
                                <div className="icon">
                                    <span className={object.image}/>
                                </div>
                                <h3>
                                    <Link to="/">{object.title}</Link>
                                </h3>
                            </div>
                            <div className="services-one__single-content">
                                <p>
                                    {object.description}
                                </p>
                                <div className="btn-box">
                                    <Link className="button-style-2" to="/">
                                        Read More
                                        <i className="icon-plus-1"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
                : <div className="text-danger mx-auto">
                    <span className="fw-bolder">NO SERVICES AVAILABLE</span>
                </div>

            }

        </>
    )
}

export default Service